/* Carrito lateral SMILU — Cart AJAX API. Sin dependencias. */
(function () {
  'use strict';
  var C = window.KD_CONFIG || {};
  var root = document.getElementById('kd-root');
  if (!root) return;

  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };

  /* ---------- dinero ---------- */
  function money(cents) {
    var fmt = C.moneyFormat || '${{amount}}';
    function group(num, dec, tsep, dsep) {
      var n = (cents / 100).toFixed(dec).split('.');
      n[0] = n[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + tsep);
      return n.length > 1 ? n[0] + dsep + n[1] : n[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return group(2, ',', '.');
        case 'amount_no_decimals': return group(0, ',', '.');
        case 'amount_with_comma_separator': return group(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(2, "'", '.');
        default: return group(2, ',', '.');
      }
    });
  }

  /* ---------- estado ---------- */
  var busy = false;
  function api(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'Error'); });
      return r.json();
    });
  }

  function open() { root.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; startTimer(); }
  function close() { root.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  /* ---------- temporizador ---------- */
  var tick = null;
  function startTimer() {
    if (!C.timerOn) return;
    var box = $('[data-kd-timer]'), clock = $('[data-kd-clock]');
    if (!box || tick) return;
    var KEY = 'kd_timer_until', until;
    try { until = +sessionStorage.getItem(KEY); } catch (e) {}
    if (!until || until < Date.now()) {
      until = Date.now() + (C.timerMin || 10) * 60000;
      try { sessionStorage.setItem(KEY, until); } catch (e) {}
    }
    box.hidden = false;
    tick = setInterval(function () {
      var left = Math.max(0, until - Date.now());
      var m = Math.floor(left / 60000), s = Math.floor(left % 60000 / 1000);
      clock.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (left <= 0) { clearInterval(tick); tick = null; box.hidden = true; }
    }, 1000);
  }

  /* ---------- render ---------- */
  function render(cart) {
    var items = $('[data-kd-items]'), empty = $('[data-kd-empty]');
    $('[data-kd-count]').textContent = cart.item_count;
    $('[data-kd-total]').textContent = money(cart.total_price);

    var visible = cart.items.filter(function (i) { return i.variant_id !== C.protId; });
    empty.hidden = visible.length > 0;

    items.innerHTML = visible.map(function (i) {
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      return '<article class="kd-item" data-key="' + i.key + '">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy" width="60" height="60">' : '<div class="kd-noimg"></div>') +
        '<div class="kd-item-b">' +
          '<p class="kd-item-t">' + esc(i.product_title.split(' - ')[0]) + '</p>' +
          (i.variant_title ? '<p class="kd-item-v">' + esc(i.variant_title) + '</p>' : '') +
          '<div class="kd-qty">' +
            '<button data-kd-qty="' + i.key + '" data-to="' + (i.quantity - 1) + '" aria-label="Quitar uno">−</button>' +
            '<span>' + i.quantity + '</span>' +
            '<button data-kd-qty="' + i.key + '" data-to="' + (i.quantity + 1) + '" aria-label="Agregar uno">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="kd-item-r">' +
          '<p class="kd-item-p">' + money(i.final_line_price) + '</p>' +
          '<button class="kd-del" data-kd-qty="' + i.key + '" data-to="0" aria-label="Eliminar">Quitar</button>' +
        '</div>' +
      '</article>';
    }).join('');

    // meta de regalo / envio
    if (C.goalOn) {
      var g = $('[data-kd-goal]'), gt = $('[data-kd-goal-text]'), bar = $('[data-kd-bar]');
      if (g) {
        var falta = Math.max(0, C.goalCents - cart.total_price);
        var pct = C.goalCents > 0 ? Math.min(100, cart.total_price / C.goalCents * 100) : 100;
        gt.textContent = falta > 0 ? (C.goalPending || '').replace('{falta}', money(falta)) : (C.goalDone || '');
        bar.style.width = pct + '%';
        g.classList.toggle('is-done', falta === 0);
        g.hidden = cart.item_count === 0;
      }
    }

    // estado del toggle de proteccion
    var pi = $('[data-kd-prot-input]');
    if (pi) pi.checked = cart.items.some(function (i) { return i.variant_id === C.protId; });

    var up = $('[data-kd-upsell]');
    if (up) up.hidden = cart.item_count === 0;
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  function refresh(openAfter) {
    return api('/cart.js').then(function (cart) { render(cart); if (openAfter) open(); return cart; });
  }

  function guard(p) {
    if (busy) return Promise.resolve();
    busy = true; root.classList.add('is-busy');
    /* Nunca un alert: con datos flojos el fetch falla y el cliente ve un
       "Load failed" del navegador encima de la pagina. Se avisa dentro del
       cajon y se registra en consola. */
    return p.catch(function (e) {
              if (console && console.warn) console.warn('[smilu carrito]', e);
              var n = root.querySelector('[data-kd-error]');
              if (n) { n.textContent = 'No pudimos actualizar el carrito. Revisa tu conexion e intentalo de nuevo.'; n.hidden = false; }
            })
            .then(function () { busy = false; root.classList.remove('is-busy'); });
  }

  /* ---------- eventos ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-kd-close]')) { e.preventDefault(); return close(); }

    var q = t.closest('[data-kd-qty]');
    if (q) {
      e.preventDefault();
      return guard(api('/cart/change.js', { id: q.dataset.kdQty, quantity: +q.dataset.to }).then(render));
    }

    var a = t.closest('[data-kd-add]');
    if (a) {
      e.preventDefault();
      return guard(api('/cart/add.js', { items: [{ id: +a.dataset.kdAdd, quantity: 1 }] }).then(function () { return refresh(); }));
    }
  });

  var protInput = $('[data-kd-prot-input]');
  if (protInput) {
    protInput.addEventListener('change', function () {
      var on = protInput.checked;
      guard(
        on ? api('/cart/add.js', { items: [{ id: C.protId, quantity: 1 }] }).then(function () { return refresh(); })
           : api('/cart.js').then(function (cart) {
               var line = cart.items.filter(function (i) { return i.variant_id === C.protId; })[0];
               return line ? api('/cart/change.js', { id: line.key, quantity: 0 }).then(render) : null;
             })
      );
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.getAttribute('aria-hidden') === 'false') close();
  });

  /* interceptar los add-to-cart del tema */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.action || f.action.indexOf('/cart/add') === -1) return;
    /* Compra directa: esos formularios llevan return_to y Shopify ya los resuelve
       con un POST nativo que deja el carrito y redirige a pagar. Este listener
       corre en captura sobre document, o sea ANTES del guardia del propio
       formulario, asi que si no nos apartamos la unidad se agrega dos veces:
       una por este fetch y otra por el submit nativo. El cliente llegaba a
       pagar 118$ en vez de 59$. */
    if (f.querySelector('[name="return_to"]')) return;
    e.preventDefault();
    guard(fetch('/cart/add.js', { method: 'POST', body: new FormData(f) })
      .then(function (r) { return r.ok ? r.json() : r.json().then(function (x) { throw new Error(x.description || 'No se pudo agregar'); }); })
      .then(function () { return refresh(true); }));
  }, true);

  /* abrir con los iconos de carrito del tema */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-kd-open]');
    if (!a) return;
    e.preventDefault();
    refresh(true);
  });

  refresh();
})();
